import { Permission } from '@cims-online/shared'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { Role, useRolesTableContext } from '../../../../../../RolesTableContext'
import {
  CreateRoleModalBody,
  CreateRoleModalValues,
} from './components/CreateRoleModalBody'
import { useCreateRoleMutation } from 'schema'
import { useProjectContext } from 'context/ProjectContext'

export function useCreateOptions(): CreateHeaderActionOptions<Role> {
  const { projectId } = useProjectContext()
  const { refetch, fetching } = useRolesTableContext()
  const [createRole] = useCreateRoleMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createRole: {
        role: { name },
      },
    }) => simpleCreateNotification(name),
  })
  return {
    loading: fetching,
    entity: 'Role',
    permission: Permission.CreateRole,
    modal: {
      type: 'simple',
      body: <CreateRoleModalBody />,
      onOk: async (values: CreateRoleModalValues) => {
        await createRole({
          variables: {
            createRoleInput: { projectId, ...values },
          },
        })
        await refetch()
      },
    },
  }
}
